module.exports = __webpack_public_path__ + "static/termsandconditions-2481f9fb75c7562eb783c4b28aecf91e.pdf";